// 设置文件
import setting from '@/setting.js'
import {
  searchUsers,
  addUser,
  updateUser,
  queryUserInfoById,
  resetPassWord
} from '@/api/sys.user'
import {
  getOrgRoles,
  getUserRole,
  setUserRole
} from '@/api/sys.role'

export default {
  namespaced: true,
  state: {
    // 用户信息
    info: setting.user.info
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} state vuex state
     * @param {*} info info
     */
    set ({
      state,
      dispatch
    }, info) {
      return new Promise(async resolve => {
        // store 赋值
        state.info = info
        // 持久化
        await dispatch(
          'd2admin/db/set', {
            dbName: 'sys',
            path: 'user.info',
            value: info,
            user: true
          }, {
            root: true
          }
        )
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     */
    load ({
      state,
      dispatch
    }) {
      return new Promise(async resolve => {
        // store 赋值
        state.info = await dispatch(
          'd2admin/db/get', {
            dbName: 'sys',
            path: 'user.info',
            defaultValue: setting.user.info,
            user: true
          }, {
            root: true
          }
        )
        // end
        resolve()
      })
    },
    /**
     * 分页查询
     */
    searchUsers ({
      dispatch
    }, {
      vm,
      data
    }) {
      //  let postData =qs.stringify(pageable);
      return searchUsers(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    addUser ({
      dispatch
    }, {
      vm,
      data
    }) {
      //  let postData =qs.stringify(pageable);
      return addUser(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    resetPassWord ({
      dispatch
    }, {
      vm,
      data
    }) {
      //  let postData =qs.stringify(pageable);
      return resetPassWord(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    getOrgRoles ({
      dispatch
    }, {
      vm,
      data
    }) {
      //  let postData =qs.stringify(pageable);
      return getOrgRoles(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    getUserRole ({
      dispatch
    }, {
      vm,
      data
    }) {
      return getUserRole(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    setUserRole ({
      dispatch
    }, {
      vm,
      data
    }) {
      return setUserRole(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateUser ({
      dispatch
    }, {
      vm,
      data
    }) {
      return updateUser(data)
        .then(async res => {
          if (res.data.status_code != '422') {
            if (vm.loginUserInfo.id == vm.userInfo.id) {
              await dispatch(
                'd2admin/user/set', {
                  name: vm.userInfo.nick_name
                }, {
                  root: true
                }
              )
            }
          }
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryUserInfoById ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryUserInfoById(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }

  }
}
